export interface ModelHubIllustration {
  path: string;
  // Intrinsic asset dimensions, passed to <img width/height> so the browser can reserve the
  // right box before the image decodes and centered copy does not jump.
  intrinsicWidth: number;
  intrinsicHeight: number;
  /**
   * Height in px the illustration renders at; width follows from the aspect ratio. Each asset
   * carries its own height rather than sharing one, because their aspect ratios differ widely
   * (portrait `predictions` at 0.62, landscape `batches` at 1.23) — matching heights would make
   * one read as much heavier than the other. Tune these to equal *visual* weight.
   */
  displayHeightPx: number;
}

export const PREDICTIONS_ILLUSTRATION: ModelHubIllustration = {
  path: '/static/img/model_hub/illustrations/predictions.png',
  intrinsicWidth: 465,
  intrinsicHeight: 750,
  displayHeightPx: 200,
};

export const BATCHES_ILLUSTRATION: ModelHubIllustration = {
  path: '/static/img/model_hub/illustrations/batches.png',
  intrinsicWidth: 921,
  intrinsicHeight: 750,
  displayHeightPx: 160,
};

export const SIGNUP_COMPLETE_ILLUSTRATION: ModelHubIllustration = {
  path: '/static/img/model_hub/illustrations/signup-complete.png',
  intrinsicWidth: 900,
  intrinsicHeight: 876,
  displayHeightPx: 225,
};
